import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface GoingConcernInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function GoingConcernInternalControls({ onBack, setActiveSection, controlsListSection }: GoingConcernInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Going Concern"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
